
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.348 9a3.935 3.935 0 00-2.192-3.525l-.739.74A2.962 2.962 0 0112.377 9a2.964 2.964 0 01-1.946 2.78l.738.739a3.934 3.934 0 002.18-3.519z","fill":"#B1B7C7"}}),_c('path',{attrs:{"d":"M11.11 9c0-.954-.827-1.726-1.846-1.726V.953c0-.216-.187-.39-.418-.39-.23 0-.417.174-.417.39v.196c-.304.247-4.933 4.423-4.933 4.423H1.56c-.551 0-.998.417-.998.933v4.99c0 .515.447.932.998.932h1.937S6.205 14.5 8.43 16.846v.202c0 .215.187.39.417.39.23 0 .417-.175.417-.39v-6.321c1.02 0 1.845-.773 1.845-1.726z","fill":"#B1B7C7"}})])
          )
        }
      }
    